import i18n from '@/lang';

export default [
  {
    key: 'BillingNote',
    icon: 'fas fa-file-signature',
    text: i18n.t('accounting.billingNotes'),
  },
  {
    key: 'Invoice',
    icon: 'fas fa-file-invoice',
    text: i18n.t('accounting.invoices'),
  },
];
